<template>
    <div class="paratwocontents">
        <div class="phonenewtwo">
            <div class="new">
                <div class="title">全新智能移动投币器</div>
                <div class="write">| 随 | 时 | 随 | 地 | 任 | 意 | 滴 |</div>
                <div class="write1">动态液晶二维码 / 多种支付方式 / 银联认证</div>
                <div class="weimaqi">
                    <img src="./images/phone/product1.png" alt="投币器">
                </div>
            </div>
        </div>
        <div class="paratwo">
            <div class="title">智能移动投币器参数</div>
            <div class="write">随时随地任性滴，银联刷卡有保障</div>
            <div class="port">
                <div class="left-num">
                        <div class="line one"></div>
                        <p>14.8cm</p>
                        <div class="line two"></div>
                </div>
                <div class="right">
                    <div class="nums">
                        <div class="line one"></div>
                        <p>4.6cm</p>
                        <div class="line two"></div>
                    </div>
                    <div class="size"><img src="./images/phone/product_size1.png" alt="投币器尺寸"></div>
                </div>
                
            </div>
            <div class="tables">
                    <table class="table one">
                        <caption>基本参数</caption>
                        <tbody>
                            <tr>
                                <td>供电电压</td>
                                <td>12V</td>
                            </tr>
                            <tr>
                                <td>供电电流</td>
                                <td>>1A</td>
                            </tr>
                            <tr>
                                <td>功　　率</td>
                                <td>12W</td>
                            </tr>
                            <tr>
                                <td>支付方式</td>
                                <td>微信、支付宝、QQ钱包，银联闪付卡、手机银联支付、CPU卡支付</td>
                            </tr>
                            <tr>
                                <td>通讯方式</td>
                                <td>支持脉冲，串口通信</td>
                            </tr>
                            <tr>
                                <td>联网方式</td>
                                <td>2G/4G（移动/联通） / WIFI / 蓝牙</td>
                            </tr>
                            <tr>
                                <td>贴面尺寸</td>
                                <td>4.6cm × 14.8cm（与设备的接触面尺寸）</td>
                            </tr>
                            <tr>
                                <td>备　　注</td>
                                <td>安装孔位与传统投币器孔位兼容，无需重新打孔</td>
                            </tr>
                        </tbody>
                    </table>
                    <table class="table two">
                        <caption>配件清单</caption>
                        <tbody>
                            <tr>
                                <td>1</td>
                                <td>闪付智能投币器</td>
                            </tr>
                            <tr>
                                <td>2</td>
                                <td>投币器连接线 × 1</td>
                            </tr>
                            <tr>
                                <td>3</td>
                                <td>GPRS天线（长） × 1；WIFI天线（短）× 1</td>
                            </tr>
                            <tr>
                                <td>4</td>
                                <td>码表连接线 × 1 （记录退奖）</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
        </div>
    </div>
</template>
<script>
export default {
  name:'paratwo',
}
</script>

<style scoped>
.paratwocontents{
    width:100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.phonenewtwo{
    width: 100%;
    /* height: 100%; */
    background-color: #fafafa;
}
.phonenewtwo .new{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.phonenewtwo .title{
     font-size: 22px;
    line-height: 22px;
    letter-spacing: 2px;
    color: #333;
    margin-top: 69px;
}
.phonenewtwo .write{
    font-size: 13px;
    line-height: 13px;
    letter-spacing: 1px;
    color: #666;
    margin-top: 19px;
}
.phonenewtwo .write1{
    font-size: 11px;
    line-height: 11px;
    letter-spacing: 1px;
    color: #666;
    margin-top: 19px;
}
.phonenewtwo .weimaqi{
    width: 60%;
     margin-top: 70px;
}
.phonenewtwo .weimaqi img{
    width: 100%;
}
.paratwo{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
  .paratwo .title{
   font-size: 22px;
    line-height: 22px;
    letter-spacing: 0.5px;
    color: #000;
    margin-top: 50px;
    }
.paratwo .write{
 font-size: 11px;
line-height: 11px;
color: #000;
margin-top: 13px;
}
.paratwo .port{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top:45px;
}
.port .nums{
    width: 73%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.nums .line{
    width: 30%;
    height: 1px;
    background: #eaeaea;
    position: relative;
}

.nums .line.one::after{
    content: '';
    position: absolute;
    height: 14px;
    width: 1px;
    background: #eaeaea;
    top: -6px;
    left: 0;
}
.nums .line.two::after{
    content: '';
    position: absolute;
    height: 14px;
    width: 1px;
    background: #eaeaea;
    top: -6px;
    right: 0;
}
.nums p{
    font-size: 11px;
	letter-spacing: 0.5px;
	color: #333333;
}
.paratwo .size{
 width: 73%;
 margin-top: 15px;
}
.paratwo .size img{
 width: 100%;
}
.paratwo .tables{
    width: 90%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
     margin: 50px 0px;
    box-sizing: border-box;
}
.paratwo table{
border-collapse:collapse;
width: 100%;
}
.paratwo table caption{
     width: 100%;
	height: 44px;
    line-height: 44px;
	background-color: #eaeaea;
    font-size: 12px;
	letter-spacing: 1px;
	color: #333333;
   border-bottom: 1px solid #eaeaea;
   border-top: 1px solid #eaeaea;
}
.paratwo table tbody tr{
    width: 100%;
    height: 44px;
}
.paratwo table tbody tr td{
    font-size: 11px;
    letter-spacing: 1px;
    color: #333333;
    height: 44px;
}
.paratwo .table.one tbody tr td,.table.two tbody tr td{
    border-bottom: 1px solid #eaeaea;
}
.paratwo .table.one tbody tr td:nth-child(1){
     width: 25%;
    height: 44px;
    text-align: center;
    border-right: 1px solid #eaeaea;
}
.paratwo .table.one tbody tr td:nth-child(2){
    width: 75%;
}
.paratwo .table.one tbody tr:nth-child(8) td:nth-child(2){
    color: #198bfe;
}
.paratwo .table.two{
    margin-top: -2px;
}
.paratwo .table.two tbody tr td:nth-child(1){
   width: 16%;
    text-align: center;
    height: 44px;
    border-right: 1px solid #eaeaea;
    box-sizing: border-box;
    padding-left: 1%;
}
.paratwo table tbody tr:nth-child(8) td:nth-child(2){
    letter-spacing: -0.6px;
}
.paratwo .table tbody tr td:nth-child(2){
    padding-left: 5%;
}
.left-num p{
    font-size: 11px;
	letter-spacing: 0.5px;
	color: #333333;
    transform: rotate(90deg);
}
    
.left-num{
    width: 30%;
    /* height: 320px; */
    height: 100vw;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    align-items: center;
    position: relative;
    top: 5vw;
}
.left-num .line{
        width: 1px;
    /* height: 80px; */
    height: 30vw;
    background: #eaeaea;
    position: relative;
}
.left-num .line.one::after,.left-numtwo .line.one::after{
    content: '';
    position: absolute;
    height: 1px;
    width: 14px;
    background: #eaeaea;
    top: 0px;
    left: -6px;
}
.left-num .line.two::after,.left-numtwo .line.two::after{
    content: '';
    position: absolute;
    height: 1px;
    width: 14px;
    background: #eaeaea;
    bottom: 0px;
    right: -6px;
}
</style>


// WEBPACK FOOTER //
// src/components/hardProduct/paratwo.vue